export class FontFamily {
  public id: number;
  public name: string;
  public uid: number;

  constructor(id: number, name: string, uid: number) {
    this.id = id;
    this.name = name;
    this.uid = uid;
  }
}
